import {keys} from 'ts-transformer-keys';

import {__} from '~/shared/src/utilities/messageCatalog';
import {SaveDataResult} from '~/shared/src/utilities/modules/data';

import {DATATABLE_SAVE_DATA} from '~/frontend/src/constants';
import {StoreState, AppDispatch, Thunk} from '~/frontend/src/store';
import {MsgParams, setMessage} from '~/frontend/src/actions/intercom';
import dataSaveData from '~/frontend/src/actions/data/saveData';
import {unsetElusiveData} from '~/frontend/src/actions/elusiveData';
import {isDataModified} from '~/frontend/src/utilities/dataUtils';
import deferedInputValueUpdate from '~/frontend/src/actions/panel/common/deferedInputValueUpdate';
import {cellEditorDataKeys} from '~/frontend/src/components/base/DataTable';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {Schema} schema
 * @param {MsgParams | undefined} [successMsgParams=undefined]
 * @param {MsgParams | undefined} [nothingToSaveMsgParams=undefined]
 * @param {MsgParams | undefined} [errorMsgParams=undefined]
 *
 */
const saveData = ( panelKey : string, schema : Schema, successMsgParams : MsgParams | undefined = undefined, nothingToSaveMsgParams : MsgParams | undefined = undefined, errorMsgParams : MsgParams | undefined = undefined ) : Thunk<Promise<SaveDataResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<SaveDataResult | false> => {
    dispatch( {
        type: DATATABLE_SAVE_DATA,
        panelKey,
        schema
    } );

    await dispatch( deferedInputValueUpdate( panelKey, panelKey, schema ) );

    const requestUid = 'saveData';

    let retVal : SaveDataResult | false = false;

    // nothing to save
    if ( !isDataModified( panelKey, schema ) ) {
        if ( !nothingToSaveMsgParams ) {
            nothingToSaveMsgParams = [
                panelKey,
                'toast',
                'nothingToSave',
                {
                    severity: 'info',
                    summary : __( 'YN.base.frontend.dataTable.save.nothingToSave.title' ),
                    detail  : __( 'YN.base.frontend.dataTable.save.nothingToSave.text' )
                }
            ];
        }

        dispatch( setMessage( ...nothingToSaveMsgParams ) );
    }

    // save request running
    else if ( getState().xhr?.[ panelKey ]?.[ requestUid ] ) {
        dispatch( setMessage(
            panelKey,
            'toast',
            'saveRunning',
            {
                severity: 'info',
                summary : __( 'YN.base.frontend.dataTable.save.running.title' ),
                detail  : __( 'YN.base.frontend.dataTable.save.running.text' )
            }
        ) );
    }

    // save
    else {
        /*dispatch( setMessage(
            panelKey,
            'toast',
            'save',
            {
                severity: 'info',
                summary : __( 'YN.base.frontend.dataTable.save.saving.title' ),
                detail  : __( 'YN.base.frontend.dataTable.save.saving.text' )
            }
        ) );*/

        const result = await dispatch( dataSaveData(
            panelKey,
            panelKey,
            requestUid,
            schema
        ) );

        retVal = result;

        if ( result.success ) {
            if ( !successMsgParams ) {
                successMsgParams = [
                    panelKey,
                    'toast',
                    'saveSuccess',
                    {
                        severity: 'success',
                        summary : __( 'YN.base.frontend.dataTable.save.saveSuccess.title' ),
                        detail  : __( 'YN.base.frontend.dataTable.save.saveSuccess.text' )
                    }
                ];
            }

            dispatch( setMessage( ...successMsgParams ) );

            // clear lastParams to trigger reload and clear cell editor data
            dispatch( unsetElusiveData( panelKey, [ 'lastParams' ].concat( cellEditorDataKeys ) ) );
        }

        // save error
        else if ( errorMsgParams ) {
            dispatch( setMessage( ...errorMsgParams ) );
        }
    }

    return retVal;
}
export type SaveData = typeof saveData;

export default saveData;
